import { useContext, useState } from "react";
import {
  ErrorMessage,
  Input,
  Label,
  Select,
} from "../components/styledComponent/formInputs";
import { Context } from "../context/MainContext";
import { addGallery } from "../api/dashboardApi";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import { Link } from "react-router-dom";

const AddGallery = () => {
  const { user } = useContext(Context);
  const [inputError, setInputError] = useState({});
  const [img, setimg] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setuploadedFile] = useState(null);

  const validate = () => {
    let uploadedFileError = "";

    if (!uploadedFile) {
      uploadedFileError = "image is required";
    }

    if (uploadedFileError) {
      setInputError((curr) => {
        return {
          uploadedFile: uploadedFileError,
        };
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    const checkValidate = validate();
    if (checkValidate && user?.id) {
      setInputError({});
      setLoading(true);

      let formData = new FormData();
      formData.append("uploadedFile", uploadedFile);

      try {
        await addGallery(formData);

        setLoading(false);
        toast.success("Gallery added successfully");
        setimg("");
        setuploadedFile("");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 4000);
      } catch (err) {
        setLoading(false);
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        toast.error(message);
      }
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];

    if (file?.size > 359715) {
      toast.warning("File too big, max size 300kb");
    } else {
      const base64 = await convertToBase64(file);
      setimg(base64);
      // setfiletype(file?.type);
      setuploadedFile(file);
    }
  };

  return (
    <div className="blog__main">
      <div className="addProperty">
        <Link to="/dashboard/gallery">
          <h2>
            <i className="ti-arrow-circle-left"></i> Add Gallery Image
          </h2>
        </Link>

        <div className="addProperty__form">
          <div className="addProperty__form__item">
            <Label htmlFor="street">
              Image <span>*</span>
            </Label>
            {/* <br /> */}
            <div>
              {img && (
                <img
                  src={img}
                  alt=""
                  style={{ width: 200, marginBottom: 10 }}
                />
              )}
            </div>
            <input
              id="cover"
              style={{ display: "none" }}
              type="file"
              onChange={(e) => handleFileUpload(e)}
              accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
            />
            {/* <label className="fileLabel" htmlFor="cover">
              <span>Max file size: 300kb</span>
            </label> */}
            <label className="careerApp__main__fileLabel" htmlFor="cover">
              {"Choose File"}
              <span>Max file size: 300kb</span>
            </label>
            <ErrorMessage style={{ top: 0 }} show={inputError?.uploadedFile}>
              {inputError?.uploadedFile}
            </ErrorMessage>
          </div>
        </div>

        <div className="addProperty__btn">
          <button className="btnMainAlt" onClick={handleSubmit}>
            {loading ? <Loading button={true} /> : "Add"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddGallery;
